<template>
    <section class="homepage-categories-list__wrapper">
        <h4 class="homepage-categories-list__title">
            Produkty
        </h4>
        <SingleLevel
            :content-component="$options.components.SingleLevel"
            :list="catalogTree"
        />
    </section>
</template>

<script>
import { mapState } from 'vuex';
import SingleLevel from '~/components/HomePage/CategoriesDropDownList/components/SingleLevel';

export default {
    name: 'CategoriesDropDownList',
    components: {
        SingleLevel,
    },
    computed: {
        ...mapState({
            catalogTree: state => state.menu.catalogTree,
        }),
    },
};
</script>

<style lang="scss">
    .homepage-categories-list__wrapper > .homepage-categories-list {
        > .homepage-categories-list__item {
            > button, > a {
                position: relative;
                padding-left: 40px;

                &::before {
                    position: absolute;
                    width: 20px;
                    height: 100%;
                    display: inline-block;
                    content: ' ';
                    left: 10px;
                    top: 0;
                    background-size: 100% auto;
                    background: url('~static/images/svg/categories/discount-light-blue.svg') center left no-repeat;
                }
            }

            &--budowa > button::before {
                background-image: url('~static/images/svg/categories/building-light-blue.svg');
            }

            &--instalacja > button::before {
                background-image: url('~static/images/svg/categories/installation-light-blue.svg');
            }

            &--wykonczenie > button::before {
                background-image: url('~static/images/svg/categories/indoor-renov-light-blue.svg');
            }

            &--urzadzanie > button::before {
                background-image: url('~static/images/svg/categories/furnishing-light-blue.svg');
            }

            &--ogrod > button::before {
                background-image: url('~static/images/svg/categories/garden-light-blue.svg');
            }

            &--narzedzia_i_artykuly > button::before {
                background-image: url('~static/images/svg/categories/multiple-tools-light-blue.svg');
            }
        }
    }
</style>
